(function() {
    'use strict';
    var EducationCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel) {
        console.log("Inside EducationCtrl");
        $scope.careerModel = {};
        $scope.careerModel.errorMessageVal = '';
        $scope.careerModel.errorMessage = false;
        $scope.careerModel.disableAddBtn = false;
        $scope.ngModel = passedModel;

        $scope.ajaxCallList = function(ajaxUrl, data, closePop) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.careerModel.disableAddBtn = false;

                $scope.careerModel.successMsg="Success";

                console.log($scope.ngModel);

                $scope.ngModel = result.data.educationHistory;
                console.log('after setting ...');
                console.log($scope.ngModel);
               if(closePop == true){
                    $uibModalInstance.close($scope.ngModel);
               } else {
                    $scope.careerModel.organisation = '';
                    $scope.careerModel.type = '';
                    $scope.careerModel.toDate = '';
                    $scope.careerModel.fromDate = '';
                    $scope.careerModel.registrationNumber = '';
                    $scope.careerModel.subjectModel.length=0;
                    $scope.careerModel.educationHistoryId = -1;
                    $scope.careerModel.referee.position  = '';
                    $scope.careerModel.referee.firstName = '';
                    $scope.careerModel.referee.lastName = '';
                    $scope.careerModel.referee.contactTime = "5273";
                    $scope.careerModel.referee.phone = '';
                    $scope.careerModel.referee.email = '';
                    $scope.careerModel.referee.postalAddress  = '';
               }

            }, function(result) {
                $scope.careerModel.disableAddBtn = false;
                $scope.careerModel.errorMessage = true;
                $scope.careerModel.errorMessageVal = errorMsg;
            });
        }

        $scope.educationSaveNg = function($event, closePop, controllerName) {

            var isValid = this.educationPopupForm.$valid;
            if(isValid){
                $event.preventDefault();
                $scope.careerModel.disableAddBtn = true;
                var data = $scope.careerModel;
                var ajaxUrl = WEBAPP_PATH +  "/"+controllerName+"/saveEducation";
                $scope.ajaxCallList(ajaxUrl , data, closePop);
            }
        }

         $scope.educationDelete = function($event, closePop) {
            $event.preventDefault();
            var data = $scope.careerModel;
            var ajaxUrl = WEBAPP_PATH + "/candidate/confirmDeleteEducation";
            $scope.ajaxCallList(ajaxUrl , data, true);
        }

        $scope.educationGapClick = function($event) {
            if($scope.careerModel.educationGap == true){
                $scope.careerModel.organisation = "Education Gap";
            } else {
                $scope.careerModel.organisation = "";
            }
        }

        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);
        }
        $scope.cancel = function() {
            $uibModalInstance.close($scope.ngModel);
        };
    }
    EducationCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params'];
    angular.module('app').controller('EducationCtrl', EducationCtrl);
}());